//Formik
import { useField } from "formik"
import FormikTextInput from "../../../../../helpers/formikInputs/FormikTextInput"
import FormikNumberInput from "../../../../../helpers/formikInputs/FormikNumberInput"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"
import assessStyles from "../../../../../styles/assessments/Assessment.module.css"

//PrimeReact
import { Button } from "primereact/button"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"

export default function QuestionOptionEntry({
  options,
  option,
  formikParentName,
  onOptionDelete,
  disabled,
}) {
  const index = options.findIndex(
    (optionsEntry) => optionsEntry.id === option.id
  )

  const thisOptionFormikName = `${formikParentName}[${index}]`

  const [, , deleteHelper] = useField(`${thisOptionFormikName}.isDeleted`)
  const [, , scoreHelper] = useField(`${thisOptionFormikName}.scoreValue`)

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: option.id,
    data: { option: option },
  })

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  }

  return (
    <div
      className={`${myStyles.questionOptionLayout} ${
        isDragging ? myStyles.draggingOrderItem : ""
      }`}
      ref={setNodeRef}
      style={style}
    >
      {disabled ? (
        <div className={`${myStyles.questionOptionLayoutIconDisabled}`}>
          <span className={`material-icons`}>{"drag_indicator"}</span>
        </div>
      ) : (
        <div
          className={myStyles.questionOptionLayoutIcon}
          {...attributes}
          {...listeners}
        >
          <span className={`material-icons`}>{"drag_indicator"}</span>
        </div>
      )}
      <div className={myStyles.questionOptionLayoutLabel}>
        <FormikTextInput
          name={`${thisOptionFormikName}.text`}
          disabled={disabled}
        />
      </div>
      <div className={myStyles.questionOptionLayoutScore}>
        <FormikNumberInput
          name={`${thisOptionFormikName}.scoreValue`}
          minFractionDigits={0}
          inputTooltip={"Score value"}
          disabled={disabled}
          onChangeCallBack={(newValue) => {
            if (newValue == null || newValue === undefined) {
              scoreHelper.setValue(0)
              scoreHelper.setTouched(true)
            }
          }}
        />
      </div>
      <div className={myStyles.questionOptionLayoutAction}>
        <Button
          type="button"
          className={assessStyles.actionButton}
          onClick={() => {
            deleteHelper.setValue(true)
            onOptionDelete()
          }}
          tooltip="Delete option"
          tooltipOptions={{ position: "bottom" }}
          disabled={disabled}
        >
          <span className={`material-icons`}>{"delete"}</span>
        </Button>
      </div>
    </div>
  )
}
